export const MONITORING_FILE_DOWNLOAD_ERROR_MESSAGE = Object.freeze({
  FORBIDDEN: 'Você não tem acesso a este arquivo.',
  NOT_FOUND: 'Arquivo não encontrado.',
  DEFAULT: 'Não conseguimos baixar o arquivo. Tente novamente.',
});
